import { Inject } from '@odinjs/odin';
import { ButtonAPI, DatePickerAPI, FieldAPI, FormAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnBeforeSubmit, OnCancel, OnChange, OnClick, OnMount, OnValidate } from '@philips-internal/oswald-ui-core/lib/client';
import { ContextType, SubmittableFragmentContext } from '@philips-internal/oswald-ui-core/lib/component/context';
import { ChangeEvent, MountEvent, SubmitEvent, ValidateEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { FragmentNames, PseudonymSuggestionChooseAnotherDateAliases } from '../../../codegen';
import PseudonymAppointmentsBaseController from '../pseudonym-appointments-base-controller';
import moment from 'moment';
import { Value } from '@philips-internal/oswald-ui-core';
import { PredefinedValidators } from '../../../utils/predefined-validators';

@Controller({ component: PseudonymSuggestionChooseAnotherDateAliases.LAYOUT_SUGGESTION_CHOOSE_ANOTHER_DATE, fragment: FragmentNames.PSEUDONYM_SUGGESTION_CHOOSE_ANOTHER_DATE })
export default class PseudonymSuggestionChooseAnotherDateController extends PseudonymAppointmentsBaseController {

  @Inject(ContextType.SUBMITTABLE_FRAGMENT)
    submittableFragmentContext!: SubmittableFragmentContext;

  @Inject(PseudonymSuggestionChooseAnotherDateAliases.BUTTON_CHOOSE_ANOTHER_DATE_SAVE)
    buttonChooseAnotherDateSave!: ButtonAPI;

  @Inject(PseudonymSuggestionChooseAnotherDateAliases.FIELD_AVAILABLE_PERIOD)
    datePickerAppointmentFieldAPI!: FieldAPI;

  @Inject(PseudonymSuggestionChooseAnotherDateAliases.FORM_SUGGESTION_CHOOSE_ANOTHER_DATE)
    formChooseAnotherDateAPI!: FormAPI;

  @Inject(PseudonymSuggestionChooseAnotherDateAliases.DATE_PICKER_RANGE)
    datePickerChooseAnotherDateAPI!: DatePickerAPI;

  @OnMount({ target: PseudonymSuggestionChooseAnotherDateAliases.FORM_SUGGESTION_CHOOSE_ANOTHER_DATE })
  handleOnMountFormSuggestionChooseAnotherDate(event: MountEvent): void {
    const formApi = event.target as FormAPI;
    const data = formApi.getValue();

    const suggestionFirstItem = this.context.get('date') as Record<string, Value>;
    const selectedDate = moment(suggestionFirstItem.date as string);
    data[this.datePickerAppointmentFieldAPI.getEntry()] = selectedDate.utc().toISOString();

    formApi.setValue(data);
  }

  @OnCancel({ target: PseudonymSuggestionChooseAnotherDateAliases.FORM_SUGGESTION_CHOOSE_ANOTHER_DATE })
  handleOnCancel(): void {
    this.submittableFragmentContext.cancel(new SubmitEvent());
  }

  @OnChange({ target: PseudonymSuggestionChooseAnotherDateAliases.DATE_PICKER_RANGE })
  async handleOnChangeDatePicker(event: ChangeEvent<string[]>): Promise<void> {
    if (!event || !event.value) {
      this.datePickerAppointmentFieldAPI.addValidator(PredefinedValidators.required());
    } else {
      this.datePickerAppointmentFieldAPI.removeValidator(PredefinedValidators.required().name);
    }

    await this.formChooseAnotherDateAPI.validate();
  }

  @OnClick({ target: PseudonymSuggestionChooseAnotherDateAliases.BUTTON_CHOOSE_ANOTHER_DATE_CANCEL })
  handleOnClickCancel(): void {
    this.formChooseAnotherDateAPI.cancel();
  }

  @OnClick({ target: PseudonymSuggestionChooseAnotherDateAliases.BUTTON_CHOOSE_ANOTHER_DATE_SAVE })
  handleOnClickSave(): void {
    this.formChooseAnotherDateAPI.submit();
  }

  @OnMount({ target: PseudonymSuggestionChooseAnotherDateAliases.DATE_PICKER_RANGE })
  handleOnMountDatePickerSuggestionChooseAnotherDate(event: MountEvent): void {
    const datePickerApi = event.target as DatePickerAPI;
    const today = moment().utc();
    const initialDate = today.day(today.day() - 1).toISOString();
    const finalDate = moment().year(0).month(1).day(1).toISOString();
    datePickerApi.clearRanges();
    datePickerApi.setInitialDate(initialDate);
    datePickerApi.addRange(finalDate, initialDate);
  }

  @OnBeforeSubmit({ target: PseudonymSuggestionChooseAnotherDateAliases.FORM_SUGGESTION_CHOOSE_ANOTHER_DATE })
  handleOnSubmitFormSuggestionChooseAnotherDate(event: SubmitEvent): void {
    this.submittableFragmentContext.submit(new SubmitEvent({ record: event.record }));
  }

  @OnValidate({ target: PseudonymSuggestionChooseAnotherDateAliases.FORM_SUGGESTION_CHOOSE_ANOTHER_DATE })
  handleOnValidadeChooseAnotherDate(event: ValidateEvent): void {
    this.buttonChooseAnotherDateSave.setEnabled(event.valid);
  }

}
